import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { FormProvider, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import * as yup from "yup";
import AddUserBasicInformation from "./AddUserBasicInformation";
import { SignUpAPI } from "api";
import { customSettings } from "utils/customConfig";
import { toast } from "react-toastify";
import PageTitle from "utils/PageTitle";
import BreadCrumbTable from "components/breadcrumb/BreadCrumbTable";

const schema = yup
  .object({
    code: yup.string(),
    loginId: yup.string().required("Login Id is required"),
    name: yup.string().required("Name is required"),
    // lastName: yup.string().required("Last Name is required"),
    email: yup.string(),
    gender: yup.string(),
    phone: yup.string().required("Phone is required"),
    dateOfBirth: yup.string(),
    password: yup.string(),
    passwordSalt: yup.string(),
    roleId: yup.string().required("Role Id is required"),
  })
  .required();

const AddUser = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  const submittedValues = {};
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {},
  });
  const { handleSubmit, reset, setValue } = methods;

  const onSubmit = async (data) => {
    let myData = {
      ...data,
      id: location?.state?.id ?? 0, // Use nullish coalescing to handle undefined or null
    };

    console.log(myData);

    try {
      if (location?.state) {
        setLoading(true);
        await SignUpAPI.post(myData);
        setLoading(false);
        toast.success("User updated successfully", {
          position: customSettings.toastPosition,
          autoClose: customSettings.toastClose,
        });
      } else {
        setLoading(true);
        await SignUpAPI.post(myData);
        setLoading(false);
        toast.success("User created successfully", {
          position: customSettings.toastPosition,
          autoClose: customSettings.toastClose,
        });
      }

      // ------- Get all object keys form data and set empty values to reset ------------
      const keys = Object.keys(data);
      for (const key of keys) {
        submittedValues[key] = "";
      }
      reset({ ...submittedValues });
      navigate(-1);
    } catch (error) {
      toast.error("Something went wrong", {
        position: customSettings.toastPosition,
        autoClose: customSettings.toastClose,
      });
      console.log(error);
    }
  };

  useEffect(() => {
    if (location?.state) {
      reset(location.state);
    }
  }, [setValue]);

  // useEffect(() => {
  //   if (location.state) {
  //     const {
  //       title,
  //       categoryGroupId,
  //       author,
  //       contentDetail,
  //       isPublished,
  //       link,
  //       sortOrder,
  //       status,
  //       tags,
  //       backgroundImage,
  //     } = location.state;
  //     let d = moment.utc(location.state?.postDate); // Parse in UTC
  //     const formattedDate = d.format("YYYY-MM-DD");

  //     setTimeout(() => {
  //       setValue("postDate", formattedDate);
  //     }, 200);

  //     setValue("title", title);
  //     setValue("categoryGroupId", categoryGroupId);
  //     setValue("author", author);
  //     setValue("contentDetail", contentDetail);
  //     setValue("isPublished", isPublished);
  //     setValue("link", link);
  //     setValue("sortOrder", sortOrder);
  //     setValue("status", status);
  //     setValue("tags", tags);
  //     setValue("backgroundImage", backgroundImage);
  //     // delete location.state.postDate;
  //     // reset(location.state);
  //   }
  // }, []);

  return (
    <>
      <PageTitle name="Administration | Users" />
      {/* <div className="py-2">
        <BreadCrumb />
      </div> */}
      <FormProvider {...methods}>
        <Form onSubmit={handleSubmit(onSubmit)} noValidate>
          <Card>
            <Card.Header className="border-bottom">
              <Row className="flex-between-center ">
                <Col md>
                  {/* <h5 className="fs-9 text-nowrap mb-2 mb-md-0">
                    {" "}
                    Administration | Users
                  </h5> */}
                  <BreadCrumbTable
                    title="Administration"
                    subTitle="Users"
                    subSubTitle={location?.state?.name}
                  />
                </Col>
                <Col xs="auto">
                  <Button
                    variant="link"
                    className="text-secondary fw-medium p-0 me-3"
                    type="button"
                    onClick={() => navigate(-1)}
                  >
                    Cancel
                  </Button>
                  <Button variant="primary" type="submit" disabled={loading}>
                    Ok
                  </Button>
                </Col>
              </Row>
            </Card.Header>
            <AddUserBasicInformation />
          </Card>
        </Form>
      </FormProvider>
    </>
  );
};

export default AddUser;
